export enum StorageAddressType {
  customer = 'CustomerAddress',
  billing = 'BillingAddress',
  shipping = 'ShippingAddress',
}
